import React, { useState, useEffect } from 'react';
import { useGift } from '../../../context/GiftContext';
import { calculateGiftStats } from '../../../utils/nurseGiftManager';

const GiftDisplay = ({ userId, teamId = null, context = null }) => {
  const { receivedGifts, loading } = useGift();
  const [displayedGifts, setDisplayedGifts] = useState([]);

  useEffect(() => {
    // Filter gifts based on userId, teamId, and context
    let filtered = receivedGifts.filter(gift => gift.toUserId === userId);
    
    if (teamId) {
      filtered = filtered.filter(gift => gift.teamId === teamId);
    }
    
    if (context) {
      filtered = filtered.filter(gift => gift.context === context);
    }
    
    setDisplayedGifts(filtered);
  }, [receivedGifts, userId, teamId, context]);

  const stats = calculateGiftStats(displayedGifts);

  if (loading) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink-500"></div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold mb-4 flex items-center">
        <span className="text-2xl mr-2">🎁</span>
        ของขวัญที่ได้รับ
      </h3>

      {/* สถิติของขวัญ */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="text-center bg-gray-50 p-3 rounded-lg">
          <div className="text-2xl mb-1">🌹</div>
          <div className="text-lg font-bold text-red-600">{stats.rose || 0}</div>
          <div className="text-sm text-gray-600">ดอกกุหลาบ</div>
        </div>
        <div className="text-center bg-gray-50 p-3 rounded-lg">
          <div className="text-2xl mb-1">💐</div>
          <div className="text-lg font-bold text-pink-600">{stats.bouquet || 0}</div>
          <div className="text-sm text-gray-600">ช่อดอกไม้</div>
        </div>
        <div className="text-center bg-gray-50 p-3 rounded-lg">
          <div className="text-2xl mb-1">🎁</div>
          <div className="text-lg font-bold text-purple-600">{stats.gift_box || 0}</div>
          <div className="text-sm text-gray-600">ของขวัญ</div>
        </div>
        <div className="text-center bg-gray-50 p-3 rounded-lg">
          <div className="text-2xl mb-1">💰</div>
          <div className="text-lg font-bold text-yellow-600">{stats.total.toLocaleString()}</div>
          <div className="text-sm text-gray-600">T Coins รวม</div>
        </div>
      </div>

      {/* รายการของขวัญล่าสุด */}
      {displayedGifts.length > 0 ? (
        <div>
          <h4 className="font-semibold mb-3">ของขวัญล่าสุด</h4>
          <div className="space-y-2 max-h-60 overflow-y-auto">
            {displayedGifts.slice(-10).reverse().map((gift) => (
              <div
                key={gift.id || gift.giftId}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div className="flex items-center space-x-3">
                  <span className="text-2xl">{gift.giftIcon}</span>
                  <div>
                    <div className="font-medium">{gift.giftName}</div>
                    <div className="text-sm text-gray-600">
                      จาก {gift.fromUserName}
                    </div>
                    {gift.message && gift.message !== gift.defaultMessage && (
                      <div className="text-xs text-gray-500 italic mt-1">
                        "{gift.message}"
                      </div>
                    )}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium text-blue-600">
                    {gift.price.toLocaleString()} T Coins
                  </div>
                  <div className="text-xs text-gray-500">
                    {gift.timestamp?.toDate ? 
                      gift.timestamp.toDate().toLocaleDateString('th-TH') :
                      new Date(gift.timestamp).toLocaleDateString('th-TH')
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <div className="text-4xl mb-2">🎁</div>
          <p>ยังไม่มีของขวัญ</p>
        </div>
      )}
    </div>
  );
};

export default GiftDisplay;



